import { render, staticRenderFns } from "./Footer-Comp.vue?vue&type=template&id=2370e44a&"
import script from "./Footer-Comp.vue?vue&type=script&lang=js&"
export * from "./Footer-Comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports